import React from "react";
import Column from "../components/Display/Column";
import { Paper } from "@material-ui/core";
import SectionHeaderText from "../components/Display/SectionHeaderText";
import { StudentServiceDetailsSearchControls } from "../components/StudentServiceDetailsSearchModal";
import { DistrictExportControls } from "../components/DistrictExportControls";

export default function ExportsView() {
  return (
    <Paper style={{ padding: "10px", height: "80dvh" }}>
      <SectionHeaderText>Export Options</SectionHeaderText>
      <Column style={{ maxWidth: "400px", gap: "10px" }}>
        <StudentServiceDetailsSearchControls />
        <DistrictExportControls />
      </Column>
    </Paper>
  );
}
